import { SHADOW_SOFT } from './format'

interface StatTilesProps {
  rsvps: number
  hosted: number
  following: number
}

function Tile({ value, label }: { value: number; label: string }) {
  return (
    <div
      style={{
        flex: 1,
        background: 'var(--surface)',
        border: '1px solid var(--line-soft)',
        borderRadius: 16,
        boxShadow: SHADOW_SOFT,
        padding: '12px 6px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--ink)' }}>{value}</div>
      <div style={{ fontSize: 10.5, color: 'var(--muted)', fontWeight: 600, marginTop: 2 }}>{label}</div>
    </div>
  )
}

export function StatTiles({ rsvps, hosted, following }: StatTilesProps) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <Tile value={rsvps} label="RSVPs" />
      <Tile value={hosted} label="Hosted" />
      <Tile value={following} label="Following" />
    </div>
  )
}
